<svg xmlns="http://www.w3.org/2000/svg" width="139.81" height="150.15" viewBox="0 0 139.81 150.15">
  <defs>
    <style>
      .cls-1 {
        fill: #c1c1c1;
        fill-opacity: 0.4;
        stroke: #fff;
        stroke-linecap: square;
        stroke-linejoin: bevel;
        stroke-width: 6px;
        stroke-dasharray: 24 12;
        fill-rule: evenodd;
      }
    </style>
  </defs>
  <path id="drugs" class="cls-1" d="M3801,3022l-76,36,7,28,27,45,15,28,66,7,20-16v-55l-15-56Z" transform="translate(-3723.19 -3019.41)"/>
</svg>
